import React, {Component} from 'react';
import {connect} from 'react-redux';
import {find, keyBy} from 'lodash';
import {reduxForm, Field, change} from 'redux-form';
import {Card, Grid, Form, Input, Icon} from 'semantic-ui-react';
import {parseOriginWarehousesAllowed, parseReasons} from '../../../common/util/options';
import {stockAdjustmentStates} from '../../../common/dictionaries/parameters';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {DropdownField} from '../../../common/components/form';
import {STOCK_ADJUSTMENT_FORM} from '../../../common/forms';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import StockAdjustmentDetail from './detail';
import StockAdjustmentFormButtons from './buttons';
import './form.scss';

const submitType = {
  'create': 'CREATE',
  'send': 'SEND',
  'remove': 'REMOVE',
  'approve': 'APPROVE',
  'reject': 'REJECT',
};

class StockAdjustmentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'documentType': '',
      'typeOfSubmit': null,
      'errors': [],
    };
    this.onCancelClick = this.onCancelClick.bind(this);
    this.changeReasonType = this.changeReasonType.bind(this);
    this.createAdjustment = this.createAdjustment.bind(this);
    this.changeTypeOfSubmit = this.changeTypeOfSubmit.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    const {permissions, adjustmentNumber, action, jdeTypeSelected} = this.props;
    if (!((hasAccessPermission(permissions, resources.StockAdjustment, scopes.Create) && !adjustmentNumber) ||
    (hasAccessPermission(permissions, resources.StockAdjustment, scopes.Create) && adjustmentNumber &&
      action === 'ver') ||
    (hasAccessPermission(permissions, resources.StockAdjustment, scopes.Edit) && adjustmentNumber &&
      (action === 'ver' || action === 'editar')) ||
    (hasAccessPermission(permissions, resources.StockAdjustment, scopes.Approve) && adjustmentNumber &&
      (action === 'ver' || action === 'aprobar')))) {
      this.props.push(paths.AccessDenied);
    }
    this.props.clearAdjustmentInfo();
    this.props.fetchSystemParameters({'type': 'text', 'word': 'aj'});
    this.props.fetchDescriptionMantainStockAdjusment();
    this.props.fetchWarehouses();
    if (adjustmentNumber) {
      this.props.fetchStockAdjustmentInfo(adjustmentNumber, {'jdeType': jdeTypeSelected});
    }
  }

  componentDidUpdate(prevProps) {
    const {reason, adjustmentType, jdeType} = this.props;
    if (reason && reason !== prevProps.reason) {
      this.setState({'documentType': `${jdeType} (${adjustmentType})`});
    }
  }

  createAdjustment() {
    const {warehouse, reason, description} = this.props;
    this.props.createNewAdjustment({warehouse, reason, description});
  }

  onSubmit(formValues) {
    const {typeOfSubmit} = this.state;
    const {code, jdeType} = this.props;
    const {sent, approved} = stockAdjustmentStates;

    if (submitType.create === typeOfSubmit) {
      this.props.createNewAdjustment(formValues);
    } else if (submitType.send === typeOfSubmit) {
      this.props.updateStockAdjustmentState(code, jdeType, sent);
    } else if (submitType.approve === typeOfSubmit) {
      this.props.updateStockAdjustmentState(code, jdeType, approved);
    }
  }

  onCancelClick() {
    this.props.goBack();
  }

  changeTypeOfSubmit(type) {
    this.setState({
      'typeOfSubmit': type,
    });
  }

  changeReasonType(event, value) {
    const {systemParameters} = this.props;
    const systemParameter = find(systemParameters, {'code': value});
    this.props.change('reasonDescription', systemParameter.description);
    this.props.change('adjustmentType', systemParameter.observation);
    this.props.change('jdeType', systemParameter.value);
    this.props.fetchDescriptionMantainStockAdjusment(value);
  }

  getWarehousesOptions() {
    const {warehouses} = this.props;
    const originWarehousesAllowed = [];

    warehouses.forEach((element) => {
      if (hasAccessPermission(this.props.permissions, `Bodega ${element.code}`, 'Ajustar Inventario')) {
        originWarehousesAllowed.push(element);
      }
    });
    return parseOriginWarehousesAllowed(originWarehousesAllowed);
  }

  getParametersOptions() {
    const {systemParameters} = this.props;
    return parseReasons(systemParameters);
  }

  renderItems() {
    const {code, action} = this.props;
    if (!code) {
      return null;
    }
    return (
      <Card fluid>
        <StockAdjustmentDetail action={action} />
      </Card>
    );
  }

  render() {
    const {code, action, handleSubmit, submitting, warehousesLoading, saving,
      description, systemParametersLoading, descriptionList, descriptionLoading} = this.props;

    return (
      <Form
        className='stock-adjustment-form'
        onSubmit={handleSubmit(this.onSubmit)}
        loading={submitting}
      >
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <Icon name='arrow left' onClick={this.onCancelClick} />
              <h2>Ajuste de stock de inventario{code ? `: Solicitud ${code}` : ''}</h2>
              <StockAdjustmentFormButtons action={action} loading={saving}
                changeTypeOfSubmit={this.changeTypeOfSubmit} />
            </div>
            <div className='filters-section'>
              <Grid textAlign='left'>
                <Grid.Row>
                  <Grid.Column width={1}>
                    <h4>Bodega:</h4>
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <Field
                      name='warehouse'
                      component={DropdownField}
                      options={this.getWarehousesOptions()}
                      disabled={code !== '' || warehousesLoading}
                      loading={warehousesLoading}
                      placeholder='Seleccione una opción'
                      required
                    />
                  </Grid.Column>
                  <Grid.Column width={1}>
                    <h4>Motivo:</h4>
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <Field
                      name='reason'
                      component={DropdownField}
                      options={this.getParametersOptions()}
                      onChange={this.changeReasonType}
                      disabled={code !== '' || systemParametersLoading}
                      loading={systemParametersLoading}
                      placeholder='Seleccione una opción'
                      required
                    />
                  </Grid.Column>
                  <Grid.Column width={1}>
                    <h4>Tipo de Doc JDE:</h4>
                  </Grid.Column>
                  <Grid.Column width={1}>
                    <Input
                      placeholder='JDE'
                      value={this.state.documentType}
                      disabled
                    />
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <h4>Observaciones:</h4>
                  </Grid.Column>
                  <Grid.Column width={6}>
                    {code === '' ?
                      <Field
                        name='description'
                        component={DropdownField}
                        options={descriptionList}
                        loading={descriptionLoading}
                        placeholder='Seleccione una opción'
                        required
                      /> : <Input
                        value={description}
                        disabled
                      />
                    }
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
        </Card>
        {this.renderItems()}
      </Form>
    );
  }
}

export {StockAdjustmentForm};

const form = reduxForm({
  'form': STOCK_ADJUSTMENT_FORM.name,
})(StockAdjustmentForm);

const mapStateToProps = (state, ownProps) => {
  const {action, adjustmentNumber, jdeTypeSelected} = ownProps.params;
  const {values, saving} = state.form.stockAdjustment;
  const {code, warehouse, reason, adjustmentType, jdeType, description} = values || {};
  const options = state.stockAdjustmentsListDescription.list.map((item) =>
    ({'key': item.id, 'text': `${item.description}`, 'value': item.id}));
  const optionsObject = keyBy(state.stockAdjustmentsListDescription.list, 'id');
  const descriptionDefault = optionsObject[description] ? optionsObject[description].description : description;

  return {
    code,
    action,
    reason,
    jdeType,
    warehouse,
    jdeTypeSelected,
    adjustmentType,
    adjustmentNumber,
    saving,
    'warehousesLoading': state.warehouses.loading,
    'warehouses': state.warehouses.list,
    'systemParametersLoading': state.parameters.loading,
    'systemParameters': state.parameters.list,
    'description': descriptionDefault,
    'permissions': state.session.permissions,
    'goBack': ownProps.history.goBack,
    'push': ownProps.history.push,
    'descriptionList': options,
    'descriptionLoading': state.stockAdjustmentsListDescription.loading,
  };
};

const {
  withRouter,
  clearAdjustmentInfo,
  fetchStockAdjustmentInfo,
  fetchSystemParameters,
  fetchWarehouses,
  createNewAdjustment,
  updateStockAdjustmentState,
  fetchDescriptionMantainStockAdjusment,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  clearAdjustmentInfo,
  fetchStockAdjustmentInfo,
  fetchSystemParameters,
  fetchWarehouses,
  createNewAdjustment,
  updateStockAdjustmentState,
  change,
  fetchDescriptionMantainStockAdjusment,
})(form));
